import { AdminConceptFormulaError } from '@/views/admin-concept-formula/admin-concept-formula.error';

export default AdminConceptFormulaError;
